import { useState } from 'react';
import { faqItems } from '@/mocks/homeMangaData';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于咻咻漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                >
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 flex-1">
                    {item.question}
                  </h3>
                  <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${
                    isOpen ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}